import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent, MatDialog } from "@angular/material";
import * as moment from "moment";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpExchangeDepositDialog } from "./add-offramp-exchange-deposit/add-offramp-exchange-deposit.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-exchange-deposits",
  templateUrl: "./offramp-exchange-deposits.component.html",
  styleUrls: ["./offramp-exchange-deposits.component.css"],
})
export class OfframpExchangeDepositsComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oDeposits: any = [];
  deposits: any = [];
  searchValue: string = '';
  statusOptions = ['REQUEST', 'PENDING', 'PROCESSING', 'APPROVED', 'COMPLETED', 'FAILED', 'REJECTED', 'CANCELLED'];
  filter: any = {
    page: 1,
    limit: 100,
    status: '',
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 0.8,
        minWidth: 90
      },
      {
        headerName: 'User',
        field: 'adminid.name',
        valueGetter: (params) => {
          const user = params.data && params.data.adminid;
          if (!user) return '';
          return user.name || user.email || '';
        },
        flex: 1.2
      },
      {
        headerName: 'Exchange',
        field: 'exchange_id.ExchangeName',
        valueGetter: (params) => {
          const exchange = params.data && params.data.exchange_id;
          return (exchange && exchange.ExchangeName) || '';
        },
        flex: 1
      },
      {
        headerName: 'Bank',
        field: 'bank_id.bank_name',
        valueGetter: (params) => {
          const bank = params.data && params.data.bank_id;
          if (!bank) return '';
          return `${bank.bank_name || ''} (${bank.bank_account_number || ''})`;
        },
        flex: 1.3
      },
      {
        headerName: 'Exchange Quote',
        field: 'exchange_quote_id',
        valueGetter: (params) => {
          const quote = params.data && params.data.exchange_quote_id;
          if (!quote) return '';
          return `${quote.from_currency || ''} -> ${quote.to_currency || ''} @ ${quote.rate || 0}`;
        },
        flex: 1.5
      },
      { headerName: 'Amount', field: 'amount', flex: 0.8 },
      { headerName: 'Status', field: 'status', flex: 0.8 },
      {
        headerName: 'CreatedAt',
        field: 'created_at',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side quick search only (does NOT call the API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.deposits = this.oDeposits.filter((x: any) => {
        return (
          (x.adminid && x.adminid.name && x.adminid.name.toLowerCase().includes(search)) ||
          (x.adminid && x.adminid.email && x.adminid.email.toLowerCase().includes(search)) ||
          (x.exchange_id && x.exchange_id.ExchangeName && x.exchange_id.ExchangeName.toLowerCase().includes(search)) ||
          (x.bank_id && x.bank_id.bank_name && x.bank_id.bank_name.toLowerCase().includes(search)) ||
          (x.status && x.status.toLowerCase().includes(search))
        );
      });
    } else {
      this.deposits = this.oDeposits;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpExchangeDeposits(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.deposits = list;
      this.oDeposits = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter('');
          this.deposits = this.oDeposits;
        }
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp exchange deposits", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      status: '',
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.searchValue = '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    this.deposits = this.oDeposits;
    this.getData();
  }

  addNewRecord() {
    const dialogRef = this.dialog.open(AddOfframpExchangeDepositDialog, {
      width: '700px',
      data: { record: {}, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpExchangeDepositDialog, {
      width: '700px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getData();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-exchange-deposits/offramp-exchange-deposits.component.ts